module.exports = __webpack_public_path__ + "static/img/product_banner_07_zh.91582a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_banner_07_zh.png
// module id = Ky4q
// module chunks = 34